import Text from '@/components/ui/custom/dataDisplay/Text';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ProjectSectionContainerProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export const ProjectSectionContainer = ({
  title,
  children,
  className,
}: ProjectSectionContainerProps) => {
  return (
    <div className={twMerge('relative rounded-md bg-base-100 p-2', className)}>
      <Text text={title} className="text-primary mb-1" />
      {children}
    </div>
  );
};
